function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 17",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.661,16.14c-0.81,0.003 -1.48,-0.655 -1.485,-1.459l-0.006,-1.044c-2.919,0.63 -3.535,-1.229 -3.535,-1.229c-0.477,-1.204 -1.165,-1.523 -1.165,-1.523c-0.952,-0.647 0.072,-0.634 0.072,-0.634c1.053,0.073 1.607,1.073 1.607,1.073c0.936,1.592 2.455,1.132 3.053,0.866c0.094,-0.673 0.367,-1.132 0.667,-1.393c-2.331,-0.263 -4.781,-1.157 -4.781,-5.147c0,-1.137 0.41,-2.066 1.082,-2.795c-0.109,-0.263 -0.468,-1.322 0.101,-2.756c0,-0 0.882,-0.28 2.886,1.067c0.857,-0.231 1.74,-0.349 2.627,-0.35c0.891,0.003 1.789,0.119 2.628,0.35c2.003,-1.347 2.883,-1.067 2.883,-1.067c0.571,1.435 0.212,2.493 0.103,2.756c0.672,0.728 1.08,1.658 1.08,2.795c-0,4 -2.455,4.881 -4.791,5.139c0.376,0.323 0.711,0.957 0.711,1.929c0,1.394 -0.005,1.963 -0.005,1.963c-0.005,0.803 -0.674,1.461 -1.484,1.459l-2.248,0l0,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.a79d1ce5332ccddc768d842137e2bf67.svg";
export { ForwardRef as ReactComponent };